// --- 基地管理 --- //

export default [
  {
    name: 'availabilityReport',
    path: '/supplySystem/:supplyId/base/:baseId/availabilityReport',
    meta: { title: '供应能力上报' },
    component: require('business/supplySystem/baseManagement/availabilityReport/list.vue').default
  },
  {
    name: 'record',
    path: '/supplySystem/:supplyId/base/:baseId/record',
    meta: { title: '历史记录' },
    component: require('business/supplySystem/baseManagement/availabilityReport/record.vue').default
  },
  {
    name: 'recordDetail',
    path: '/supplySystem/:supplyId/base/:baseId/detail',
    meta: { title: '历史记录详情' },
    component: require('business/supplySystem/baseManagement/availabilityReport/detail.vue').default
  },
  {
    name: 'baseProductionData',
    path: '/supplySystem/:supplyId/base/:baseId/baseProductionData',
    meta: { title: '基地生产数据' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseProductionData/list.vue').default
  },
  {
    name: 'addBaseProductionData',
    path: '/supplySystem/:supplyId/base/:baseId/addBaseProductionData',
    meta: { title: '新增基地生产数据' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseProductionData/add.vue').default
  },
  {
    name: 'deliveryList',
    path: '/supplySystem/:supplyId/base/:baseId/deliveryList',
    meta: { title: '送货清单' },
    component: require('business/supplySystem/baseManagement/deliveryList/list.vue').default
  },
  {
    name: 'baseCultivationData',
    path: '/supplySystem/:supplyId/base/:baseId/baseCultivationData',
    meta: { title: '基地养殖数据' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseCultivationData/list.vue').default
  },
  {
    name: 'baseStatistics',
    path: '/supplySystem/:supplyId/base/:baseId/baseStatistics',
    meta: { title: '基地数据统计' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseStatistics/list.vue').default
  }
]
